import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import ModalRoboLancesImg from 'assets/images/modal/modal-robo-de-lances-comprasnet.png';
import { Container } from './styles';

const ModalRoboLances = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    if (!hasCookie('modalRoboComprasNet')) {
      setShowModal(true);
    }
  }, []);

  const handleClose = () => {
    setCookie('modalRoboComprasNet', 'true');
    setShowModal(false);
  };

  return (
    <Modal show={showModal} size="lg" onHide={handleClose} centered>
      <Container>
        <div className="position-relative text-center bg-modal">
          <button
            type="button"
            className="close text-white"
            data-dismiss="modal"
            onClick={handleClose}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <a href="/robo_lance" onClick={handleClose}>
            <img
              className="card-img-top"
              src={ModalRoboLancesImg}
              alt="Robô de Lances - Compras.gov"
            />
          </a>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalRoboLances;
